import { GoalEventType } from 'modules/goals/types';
import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { RestQueryHookOptions } from 'utils/hooks/api/useRestQuery';

export const MISSION_CONTROL_GOAL_TOP_CAMPAIGN_URL = '/i/goals/bestCampaignsForGoal';

export type BestCampaign = {
  campaignId: number;
  campaignName: string;
};

export type TopCampaign = {
  bestCampaign: BestCampaign;
  count: number;
};

export type QueryGoalTopCampaignRequest = {
  conversionEvent: string;
  startTime: string;
  endTime: string;
  eventType: GoalEventType;
};

export type UseQueryGoalTopCampaignState = ReturnType<typeof useQueryGoalTopCampaign>;

export const useQueryGoalTopCampaign = (
  params?: QueryGoalTopCampaignRequest,
  options?: RestQueryHookOptions<TopCampaign>,
) => {
  const {
    data,
    isLoading,
    error: errorMessage,
    isError: hasError,
    refetch,
  } = useRestPostQuery<TopCampaign>(MISSION_CONTROL_GOAL_TOP_CAMPAIGN_URL, params, options);

  return {
    topCampaign: data,
    isLoading,
    hasError,
    errorMessage,
    refetch,
  };
};
